import { requestService } from '../services';
import { processFailure, showErrorsIfNeed } from './utils';
import { uploadConst } from '../consts';
import { processUserRequests } from './requests.actions';
import { getThumbnail } from '../util/thumbnail';

export const uploadActions = {
    addFile,
    cancelFile,
};

function addFile(fileData) {
    const fileId = fileData.file.name + Date.now();
    return async (dispatch, getState) => {
        const {
            requests: { eventName, requests: oldRequests },
        } = getState();
        try {
            const previousFileIds = getRequestFiles(oldRequests, fileData.requestId).reduce((result, f) => {
                result[f.id] = true;
                return result;
            }, {});
            dispatch(request());
            const requests = await requestService.addReqFile(fileData, (e) => dispatch(progress(e.total, e.loaded)));
            dispatch(success());
            processUserRequests(requests, eventName, false, dispatch, getState);
            if (requests) {
                const newFileIds = getRequestFiles(requests, fileData.requestId)
                    .filter((f) => !previousFileIds[f.id])
                    .filter((f) => f.filename === fileData.file.name)
                    .map((f) => f.id);
                for (const fileId of newFileIds) {
                    for (const [imageSize, imageType] of [
                        [48, 'png'],
                        [256, 'jpeg'],
                        [1200, 'jpeg'],
                    ]) {
                        try {
                            console.log(
                                `Create thumbnail with size ${imageSize} and type ${imageType} for file ${fileId}`
                            );
                            const resultFile = await getThumbnail(fileData.file, imageSize, imageType);
                            if (fileData.file.size < resultFile.length) {
                                console.log(
                                    `Thumbnail size (${resultFile.length}) is bigger than original file (${fileData.file.size}). Skip saving thumbnail.`
                                );
                                break;
                            }
                            const newRequests = await requestService.addReqFileThumbnail({
                                fileId,
                                size: imageSize + 'x' + imageSize,
                                content: resultFile,
                            });
                            processUserRequests(newRequests, eventName, false, dispatch, getState);
                        } catch (err) {
                            console.error(`Ошибка загрузки миниатюры для "${fileData.file.name}": ${err}`);
                        }
                    }
                }
            }
        } catch (error) {
            onError(error, dispatch);
        }
    };

    function getFileData(p) {
        return {
            id: fileId,
            fileTypeId: fileData.fileTypeId,
            name: fileData.file.name,
            progress: p,
        };
    }

    function request() {
        return {
            type: uploadConst.UPLOAD_REQUEST,
            requestId: fileData.requestId,
            file: getFileData(0),
        };
    }
    function success() {
        return {
            type: uploadConst.UPLOAD_SUCCESS,
            requestId: fileData.requestId,
            file: getFileData(100),
        };
    }
    function progress(total, loaded) {
        return {
            type: uploadConst.UPLOAD_PROGRESS,
            requestId: fileData.requestId,
            file: getFileData(Math.round((loaded * 100) / total)),
        };
    }
    function onError(error, dispatch) {
        processFailure({
            dispatch,
            error,
            action: {
                type: uploadConst.UPLOAD_FAILURE,
                requestId: fileData.requestId,
                file: getFileData(),
                errors: 'error',
            },
        });
        showErrorsIfNeed(error, [400]);
    }
}

function cancelFile(fileData) {
    return {
        type: uploadConst.UPLOAD_CANCEL,
        requestId: fileData.requestId,
        file: {
            name: fileData.filename,
        },
    };
}

function getRequestFiles(requests, requestId) {
    let targetRequest = requests?.author.find((request) => request.id === requestId);
    if (!targetRequest) targetRequest = requests?.participant.find((request) => request.id === requestId);
    return targetRequest?.files || [];
}
